// Libs / Helpers
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Label from "Components/forms/label/Label";
import * as KeyConstants from "Utils/constants/keyConstants.js";

// Style
import "./Checkbox.scss";

const Checkbox = ({
  checkBoxKey,
  onChange,
  id,
  isChecked,
  label,
  readonly,
  extraClass,
  optionalTooltip,
  optionalTooltipTitle,
  disabled,
  extraInputStyle,
  extraLabelStyle,
  isSvg,
}) => {
  const wrapperClass = classnames("checkbox-field", {
    [extraClass]: extraClass,
  });
  const labelClass = classnames("checkbox-label", {
    checked: !isSvg ? isChecked : false,
    readonly,
  });

  const checkBoxStyle = !isChecked
    ? {
        cursor: "pointer",
        border: "1px solid #c4c4c4",
        background: "white",
        height: 30,
        width: 30,
      }
    : { cursor: "pointer", height: 30, width: 30 };

  const callSpace = (e, id) => {
    var keyCode = e.which || e.keyCode;

    const eventCode = e.code
      ? e.code + "_" + e.ctrlKey
      : e.key + "_" + e.ctrlKey;
    if (
      eventCode == KeyConstants.SPACE_BUTTON ||
      keyCode == 32 ||
      e.key == "Space" ||
      eventCode == KeyConstants.SPACE_KEY_CODE_BUTTON
    ) {
      onChange(id, label);
      e.preventDefault();
    }
  };
  const avoidSpace = (e) => {
    var keyCode = e.which || e.keyCode;
    const eventCode = e.code
      ? e.code + "_" + e.ctrlKey
      : e.key + "_" + e.ctrlKey;
    if (
      eventCode == KeyConstants.SPACE_BUTTON ||
      keyCode == 32 ||
      e.key == "Space" ||
      eventCode == KeyConstants.SPACE_KEY_CODE_BUTTON
    ) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      e.preventDefault();
    }
  };

  const onLabelClick = (checkBoxKey, label) => {
    if (!disabled) {
      onChange(checkBoxKey, label);
    }
  };

  return (
    <div
      className={wrapperClass}
      style={{ display: "inline-flex", paddingLeft: 0 }}
    >
      {!isSvg && (
        <input
          type="checkbox"
          className="checkbox"
          onChange={() => onChange(checkBoxKey, label)}
          id={id}
          checked={isChecked}
          disabled={disabled || readonly}
          style={extraInputStyle}
        />
      )}
      {isSvg && !disabled && (
        <span
          id={id}
          style={checkBoxStyle}
          onKeyDown={(event) => avoidSpace(event)}
          onKeyUp={(event) => callSpace(event, checkBoxKey)}
          onClick={() => onChange(checkBoxKey, label)}
          tabIndex="0"
          className="checkBoxFocus"
        >
          {!isChecked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path />
            </svg>
          )}
          {isChecked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              color="#262aff"
              viewBox="0 0 24 24"
            >
              <path d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" />
            </svg>
          )}
        </span>
      )}
      {isSvg && disabled && (
        <span style={checkBoxStyle}>
          {!isChecked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path />
            </svg>
          )}
          {isChecked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              color="#262aff"
              viewBox="0 0 24 24"
            >
              <path d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" />
            </svg>
          )}
        </span>
      )}
      <Label
        htmlFor={id}
        labelClass={labelClass + " label-cursor"}
        extraStyle={extraLabelStyle}
      >
        <span onClick={() => onLabelClick(checkBoxKey, label)}>{label}</span>
      </Label>
    </div>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  readonly: PropTypes.bool,
  label: PropTypes.string,
  extraClass: PropTypes.string,
  optionalTooltip: PropTypes.string,
  optionalTooltipTitle: PropTypes.string,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  id: null,
  label: "",
  disabled: false,
  readonly: false,
  extraClass: "",
  isChecked: false,
  optionalTooltip: null,
  optionalTooltipTitle: null,
  extraInputStyle: {},
  extraLabelStyle: {},
  isSvg: true,
  checkBoxKey: 0,
};

export default Checkbox;
